import { library } from '@fortawesome/fontawesome-svg-core';
import { faShoppingCart, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import ActiveListFilters from '@jetshop/ui/Filter/ActiveFilters';
import BoolFilters from '@jetshop/ui/Filter/FilterTypes/BoolFilters';
import ListFilterAccordion from '@jetshop/ui/Filter/FilterTypes/List/ListFilterAccordion';
import RangeFilterAccordion from '@jetshop/ui/Filter/FilterTypes/Range/RangeFilterAccordion';
import React, { Fragment } from 'react';
import styled from 'react-emotion';

library.add(faShoppingCart, faTimes);

const EmptyButtonIcon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  margin-right: 10px;
  color: #a5a5a5;
`;

const Wrapper = styled('div')`
  background: #fff;
  padding-bottom: 100px;
  padding-top: 67px;
  position: relative;

  .slider {
    .handle {
      border-radius: 100%;
    }
    + button {
      height: 40px;
    }
  }

  label {
    padding: 1rem;
    border: 0;
    border-top: 1px solid #ddd;
    height: auto;
    text-transform: uppercase;
  }
  button {
    padding: 0 1rem;
    border: 0;
    border-top: 1px solid #ddd;
    text-transform: uppercase;
    &:focus {
      outline: none;
      *:focus {
        outline: none;
      }
    }
    + div {
      > button {
        // FILTER BUTTON
        background: none;
        justify-content: flex-start;
        height: 30px;
        padding-left: 25px;
        font-size: 14px;
        background: #fff;
        border: 0;
        padding-right: 0;

        &:before {
          content: '';
          height: 15px;
          width: 15px;
          background: none;
          border: 1px solid black;
          margin-right: 10px;
        }

        svg {
          position: absolute;
          left: 28px;
          top: 50%;
          transform: translateY(-50%);
          width: 10px;
          * {
            fill: #333333;
          }
        }

        &:last-child {
          margin-bottom: 10px;
        }
      }
    }
  }
`;

const FilterBottom = styled('section')`
  display: none;
  justify-content: center;
  width: 100%;
  padding: 20px 10px;
  border-top: 1px solid #ddd;

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border: 0;

  aside {
    width: 50%;
    margin: 0 10px;
    button {
      background: #cd3132;
      color: white;
      width: 100%;
    }
    div {
      display: none;
    }
  }
  button {
    width: 50%;
    height: 40px;
    text-decoration: none;
    margin: 0;
    text-transform: uppercase;
    font-size: 14px;
    background-image: none;
  }
  > button {
    width: 50%;
    background: #333333;
    color: white;
    margin: 0 10px;
  }
`;

const CloseModal = styled('div')`
  display: none;
  align-items: center;
  justify-content: flex-start;
  padding: 17px;
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: white;
  border-bottom: 1px solid #ddd;
  svg path {
    color: black;
  }
`;

export default ({ filters, sortOrders, close, ...props }) => {
  const listFilters = (filters || []).filter(
    (filter) => filter.__typename === 'ListFilter'
  );

  const rangeFilters = (filters || []).filter(
    (filter) => filter.__typename === 'NumericRangeFilter'
  );

  return (
    <section {...props}>
      {filters ? (
        <Wrapper>
          <CloseModal className="close-modal" onClick={close}>
            <EmptyButtonIcon icon={['fal', 'times']} /> <span>Stäng</span>
          </CloseModal>
          <Accordion single>
            {(accordionProps) => (
              <Fragment>
                <ListFilterAccordion
                  listFilters={listFilters}
                  accordionProps={accordionProps}
                />
                <RangeFilterAccordion
                  rangeFilters={rangeFilters}
                  accordionProps={accordionProps}
                  startingIdx={listFilters.length}
                />

                <BoolFilters filters={filters} />

                <FilterBottom className="filter-bottom">
                  <button onClick={close}>Visa resultat</button>
                  <ActiveListFilters filters={filters} />
                </FilterBottom>
              </Fragment>
            )}
          </Accordion>
        </Wrapper>
      ) : null}
    </section>
  );
};
